import { render, staticRenderFns } from "./acesso.vue?vue&type=template&id=e5b54c0c"
import script from "./acesso.vue?vue&type=script&lang=js"
export * from "./acesso.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports